/*
 * @Description: 用户 vuex 仓库
 * @Author: 王振
 * @Date: 2021-07-06 16:27:14
 * @LastEditors: 王振
 * @LastEditTime: 2021-08-09 14:41:22
 */

import { postLoginAPI, postLogoutAPI, getUserAPI } from "@/api/login";
import { getToken, setToken, removeToken, setUser } from "@/utils/auth";

const getDefaultState = () => {
  return {
    token: "", //用户token
    userInfo: {}, //用户数据
  };
};

const state = getDefaultState();

const mutations = {
  //设置token
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  //设置个人信息
  SET_USERINFO: (state, value) => {
    state.userInfo = value;
  },
  //重置state
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState());
  },
};

const actions = {
  // 用户登录
  login({ commit }, userInfo) {
    const { username, password } = userInfo;
    return new Promise((resolve, reject) => {
      postLoginAPI({ username: username.trim(), password: password })
        .then((response) => {
          const { data } = response;
          commit("SET_TOKEN", data.token);

          setToken(data.token);

          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // 获取用户信息
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getUserAPI()
        .then((response) => {
          const { data } = response;

          if (!data) {
            return reject("验证失败，请重新登录！");
          }
          commit("SET_USERINFO", data);
          setUser(data);
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // 用户退出登录
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      postLogoutAPI(state.token)
        .then(() => {
          removeToken(); // must remove  token  first
          commit("RESET_STATE");
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // 重置token
  resetToken({ commit }) {
    return new Promise((resolve) => {
      removeToken(); // must remove  token  first
      commit("RESET_STATE");
      resolve();
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/pages/system/store/modules/user.js